import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Icon as EshavaIcon, IconSize } from 'eshava-shared';

import { IconName } from './icon-name';

export type { IconSize };

/**
 * The portal's icon: `eshava-icon` from the package, with the name typed to this application's sprite.
 *
 * **The wrapper exists for the type, not for the markup.** The package renders
 * `<use href="#icon-{name}">` and takes a plain string, because the sprite belongs to the
 * application and a package typing that field would decide which symbols may exist anywhere. The
 * portal generates `IconName` from the SVG files it holds, so here the name can be checked -- and a
 * typo in one of forty-four templates is caught by the compiler rather than by an empty square on
 * screen.
 */
@Component({
  selector: 'portal-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EshavaIcon],
  template: `<eshava-icon [name]="name()" [size]="size()" [label]="label()" />`
})
export class Icon {
  readonly name = input.required<IconName>();
  readonly size = input<IconSize>('md');
  readonly label = input<string>('');
}
